function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.6455638,13.394 L9.99956382,10.75 L9.99956382,4.5 C9.99956382,4.224 10.2235638,4 10.4995638,4 L13.4995638,4 C13.7765638,4 13.9995638,3.777 13.9995638,3.5 L13.9995638,0.5 C13.9995638,0.224 13.7765638,0 13.4995638,0 L9.49956382,0 C9.22356382,0 8.99956382,0.224 8.99956382,0.5 L8.99956382,9.688 L8.22456382,8.828 C7.83756382,8.475 7.21056382,8.475 6.82456382,8.828 L0.340563819,15.457 C-0.282436181,16.026 -0.0174361807,17 0.864563819,17 L9.21256382,17 C9.37756382,17 9.53756382,16.935 9.65456382,16.818 L12.6445638,13.836 C12.7675638,13.714 12.7675638,13.516 12.6455638,13.394 M19.4045638,17 L11.9985638,17 C11.7195638,17 11.5805638,16.664 11.7775638,16.466 L13.7515638,14.5 L15.8305638,12.28 C16.0625638,12.065 16.4395638,12.065 16.6715638,12.28 L19.8245638,16.059 C20.1995638,16.407 19.9335638,17 19.4045638,17",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 -2 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/success.803a6374.svg";
export { SvgComponent as ReactComponent };